import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TextField,
  InputAdornment,
  IconButton,
  Menu,
  Typography,
  Button,
  Tooltip,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Topbar from "../../admin/layouts/Topbar";
import Addproduct from "../../admin/components/Add_product";
import CircularProgress from "@mui/material/CircularProgress";
import instance from "../../utils/Api";
import Statusproduct from "../../admin/components/Status_product";
import { useGlobalContext } from "../../Contex"; // Adjust the path
import edit from '../../superadmin/assets/icons/add-icon.svg';

const Messages = () => {
  const { openDialog, setOpenDialog } = useGlobalContext();
  const { openStatusDialog, setOpenStatusDialog } = useGlobalContext(); //status popup
  const { loading, setLoading } = useGlobalContext(); // State to handle loading
  const { anchorEl, setAnchorEl } = useGlobalContext(); //filter
  const { searchTerm, setSearchTerm } = useGlobalContext(); //search state
  const open = Boolean(anchorEl);
  const [page, setPage] = useState(0);
  const rowsPerPage = 10; // Fixed rows per page
  const startIndex = page * rowsPerPage; // Calculate the start and end index for pagination
  const [products, setProducts] = useState([]);
  const [totalCount, setTotalCount] = useState(0); // total messages count from API
  const [messagecounts, setMessagecounts] = useState([]);
  const [addproducts, setAddproducts] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  // console.log(products);

  // Handle search
  const filteredProducts = products.filter((product) => {
    const searchTermLower = searchTerm.toLowerCase(); // Ensure searchTerm is always a string
    return (
      product?.textMessage?.toLowerCase().includes(searchTermLower)
      // product?.unit?.toLowerCase().includes(searchTermLower)
      // product?.status?.toLowerCase().includes(searchTermLower)
      // product?.age_limit?.toString().includes(searchTermLower)||
    );
  });
  // console.log(filteredProducts);

  //handle change
  const handleChangePage = (event, newPage) => {
    setPage(newPage); // Adjust to be 1-based
  };

  //filter function open menu
  const handleClick1 = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //filter function close menu
  const handleClose1 = () => {
    setAnchorEl(null);
  };

  //fetch products
  const fetchProducts = async (pageParam = page) => {
    try {
      setLoading(true);

      const response = await instance.get(
        `/api/v1/newrouts/getMessages?page=${pageParam + 1}&limit=${rowsPerPage}`
      );

      setProducts(response.data.data);
      setTotalCount(response.data.pagination.total);
    } catch (error) {
      console.error("Error fetching Products:", error.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchmessagecounts = async (date) => {
    try {
      const month = date.format('YYYY-MM');
      const response = await instance.get(`/api/v1/newrouts/getMessagesCount/${month}`);
      setMessagecounts(response.data);
    } catch (error) {
      console.error("Error fetching message count:", error.message);
    }
  }

  useEffect(() => {
    fetchProducts(1);
    if (selectedDate) {
      fetchmessagecounts(selectedDate);
    }
    setAddproducts(false); // Reset after fetching
    setLoading(true);
  }, [addproducts]);

  useEffect(() => {
    fetchProducts(page);
  }, [page]);

  // Function to handle opening the popup for adding new admin
  const handleAddClick = () => {
    setSelectedProduct(null); // Clear selected admin (add new mode)
    setOpenDialog(true); // Open the popup
  };

  const handleEditClick = (product) => {
    setSelectedProduct(product);
    setOpenDialog(true);
  }

  // Function to handle status click and open the popup
  const handleStatusClick = (product) => {
    setSelectedProduct(product); // Store the selected product
    setOpenStatusDialog(true); // Open the popup
  };


  return (
    <React.Fragment>
      <Topbar />
      {loading ? (
        <div className="loading">
          <CircularProgress />
        </div>
      ) : (
        <section className="main">
          <div className="employees-text">
            <Typography variant="h5">Messages List</Typography>
            {/* <Button variant="outlined" onClick={handleAddClick}>
              Add Item
            </Button> */}
          </div>
          <div className="employees-main">
            <div className="employees-content ">
              <div className="search-options">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    views={['year', 'month']}
                    label="Year and Month"
                    value={selectedDate}
                    onChange={(newValue) => {
                      setSelectedDate(newValue);
                      if (newValue) {
                        fetchmessagecounts(newValue);
                      }
                    }}
                    slotProps={{ textField: { helperText: null } }}
                  />
                </LocalizationProvider>
                <Typography variant="h6" sx={{ marginLeft: 2 }}>Total Message : {messagecounts?.count}</Typography>
                {/* <TextField
                  placeholder="Search"
                  type="search"
                  variant="outlined"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setPage(0);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                /> */}
              </div>
              <div className="pagination-options table-pagination">
                <div className="pagination-animation"></div>
                <TablePagination
                  component="div"
                  count={totalCount}              // API total
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={(e, newPage) => setPage(newPage)}
                  rowsPerPageOptions={[]}
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from} to ${to} of ${count}`
                  }
                />
              </div>
            </div>
            <div className="employee-table">
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <div className="employee-name">S.NO</div>
                      </TableCell>
                      <TableCell>
                        <div className="employee-name">Message</div>
                      </TableCell>
                      <TableCell>
                        <div className="employee-name">Sent Count</div>
                      </TableCell>
                      <TableCell>
                        <div className="employee-name">Sent Date</div>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {products.length > 0 ? (
                      products.map((product, index) => (
                        <TableRow abIndex={-1} key={product._id}>
                          <TableCell component="th" scope="row">
                            {startIndex + index + 1}
                          </TableCell>
                          <TableCell align="left">
                            {product?.textMessage}
                          </TableCell>
                          <TableCell align="left">{product?.count}</TableCell>
                          <TableCell align="left">{new Date(product?.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          <Typography>No Data Found</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </section>
      )}
    </React.Fragment>
  );
};

export default Messages;
